import * as yup from "yup";

export const adminDetailSchema = yup.object().shape({
  onsiteRemote: yup.string().notRequired(),

  multiSponsor: yup.boolean().notRequired(),
  capaNeeded: yup.boolean().notRequired(),
  additionalDetails: yup.string().notRequired(),
  auditors: yup.object(),
  requestDate: yup.object({
    startDate: yup.date(),
  }),
  planningMeetingDate: yup.object({
    startDate: yup.date(),
  }),
  firstAssessmentDate: yup.object({
    startDate: yup.date(),
  }),
  agreedDraftDate: yup.object({
    startDate: yup.date(),
  }),
  introEmailDate: yup.object({
    startDate: yup.date(),
  }),
  introMeetingDate: yup.object({
    startDate: yup.date(),
  }),
  assessmentDuration: yup.object({
    startDate: yup.date(),
  }),
  assessmentCompletionDate: yup.object({
    startDate: yup.date(),
  }),
  firstDraftUplaodedDate: yup.object({
    startDate: yup.date(),
  }),

  firstDraftDelieveredSponsorDate: yup.object({
    startDate: yup.date(),
  }),
  draftReviewDate: yup.object({
    startDate: yup.date(),
  }),
  draftDelieveredToVendorDate: yup.object({
    startDate: yup.date(),
  }),
  FinalReportDate: yup.object({
    startDate: yup.date(),
  }),
  capaDelieveredToSponsorDate: yup.object({
    startDate: yup.date(),
  }),

  providerName: yup.string().notRequired(),
  providerEmail: yup.string().email().notRequired(),
  providerPhone: yup
    .number()
    .transform((value, originalValue) => {
      // Convert empty string to null
      return originalValue === "" ? null : value;
    })
    .typeError("Phone number must be a valid number")
    .positive("Phone number must be positive")
    .integer("Phone number must not contain decimals")
    .min(1000000000, "Phone number must be at least 10 digits")
    .max(999999999999999, "Phone number must be at most 15 digits")
    .nullable() // Allows the value to be null
    .notRequired(), // Makes the field optional
  providerAddress: yup.string().notRequired(),
  providerCity: yup.string().notRequired(),
  providerState: yup.string().notRequired(),
  providerCountry: yup.string().notRequired(),
  sponsors: yup.array().of(
    yup.object().shape({
      sponsorName: yup.string().required("Sponsor Name is required"),
      sponsorEmail: yup
        .string()
        .email("Invalid email format")
        .required("Sponsor Email is required"),
      sponsorPhone: yup
        .number()
        .transform((value, originalValue) => {
          // Convert empty string to null
          return originalValue === "" ? null : value;
        })
        .typeError("Phone number must be a valid number")
        .positive("Phone number must be positive")
        .integer("Phone number must not contain decimals")
        .min(1000000000, "Phone number must be at least 10 digits")
        .max(999999999999999, "Phone number must be at most 15 digits")
        .nullable() // Allows null values (empty)
        .notRequired(), // Makes the field optional
    })
  ),
});
